import React, { useState } from 'react';
import { Card, Typography, Autocomplete, TextField, Box, Chip, Paper } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HealingIcon from '@mui/icons-material/Healing';
import redFlags from '../utils/redFlagsarry';

// בניית רשימת השמות — פעם אחת בלבד, ללא useEffect
const allNames = (() => {
    const names = [];
    redFlags.forEach((e) => {
        for (const key in e) {
            if (Object.prototype.hasOwnProperty.call(e, key)) {
                names.push(e[key].name);
            }
        }
    });
    return names;
})();

const RedFlags = () => {
    const [value, setValue] = useState(null);
    const [treetmant, settreetmant] = useState([]);
    const [qustion, setqustion] = useState([]);
    const [redf, setredf] = useState([]);

    const handleChange = (val) => {
        if (!val) { setredf([]); setqustion([]); settreetmant([]); return; }
        redFlags.forEach((e) => {
            for (const key in e) {
                if (Object.prototype.hasOwnProperty.call(e, key)) {
                    const element = e[key];
                    if (element.name === val) {
                        setqustion(element.qustions);
                        setredf(element.redFlags);
                        settreetmant(element.treetmant);
                    }
                }
            }
        });
    };

    const hasContent = redf.length > 0 || qustion.length > 0 || treetmant.length > 0;

    return (
        <Card sx={{ margin: '2em 1em', padding: '1.5em' }} id="ana">
            <Typography variant="h5" gutterBottom>אנמנזה</Typography>

            <Autocomplete
                fullWidth
                options={allNames}
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                    handleChange(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="חיפוש תלונה" />}
            />

            {hasContent && (
                <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>

                    {/* דגלים אדומים */}
                    {redf.length > 0 && (
                        <Paper variant="outlined" sx={{ p: 1.5, borderColor: 'error.main', borderWidth: 1.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                                <FlagIcon color="error" fontSize="small" />
                                <Typography variant="subtitle1" fontWeight="bold" color="error.main">
                                    דגלים אדומים
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                {redf.map((i, e) => (
                                    <Box key={e} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                        <Chip
                                            label={e + 1}
                                            size="small"
                                            color="error"
                                            sx={{ minWidth: 28, height: 22, fontSize: '0.7rem', mt: 0.2 }}
                                        />
                                        <Typography variant="body2">{i}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Paper>
                    )}

                    {/* שאלות ספציפיות */}
                    {qustion.length > 0 && (
                        <Paper variant="outlined" sx={{ p: 1.5, borderColor: 'warning.main', borderWidth: 1.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                                <HelpOutlineIcon color="warning" fontSize="small" />
                                <Typography variant="subtitle1" fontWeight="bold" color="warning.main">
                                    שאלות ספציפיות
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                {qustion.map((i, e) => (
                                    <Box key={e} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                        <Chip
                                            label={e + 1}
                                            size="small"
                                            color="warning"
                                            sx={{ minWidth: 28, height: 22, fontSize: '0.7rem', mt: 0.2 }}
                                        />
                                        <Typography variant="body2">{i}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Paper>
                    )}

                    {/* טיפול */}
                    {treetmant.length > 0 && (
                        <Paper variant="outlined" sx={{ p: 1.5, borderColor: 'success.main', borderWidth: 1.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                                <HealingIcon color="success" fontSize="small" />
                                <Typography variant="subtitle1" fontWeight="bold" color="success.main">
                                    טיפול
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                {treetmant.map((i, e) => (
                                    <Typography key={e} variant="body2">{i}</Typography>
                                ))}
                            </Box>
                        </Paper>
                    )}

                </Box>
            )}
        </Card>
    );
};

export default RedFlags;
